const STRATEGIC_INITIATIVES_NAMESPACE = 'jbp-strategic-initiatives'

export const STRATEGIC_INITIATIVES_TRANSLATION_KEYS = {
  title: `${STRATEGIC_INITIATIVES_NAMESPACE}-title`,
  keyObjective: `${STRATEGIC_INITIATIVES_NAMESPACE}-key-objective`,
}
